import { get, truncate } from 'lodash'

const mpgConfigSchema = ({ participant, mpgSession, currentLocale, intl }) => {
  const locale = currentLocale === 'zh-hans' ? 'zh' : currentLocale

  const name = intl.formatMessage({
    defaultMessage: 'Payment',
    id: 'moduleTitle.payment'
  })

  return {
    merchant: get(mpgSession, 'merchantId'),
    order: {
      amount() {
        return get(participant, 'awardFeeAmount')
      },
      currency: get(participant, 'awardFeeCurrency'),
      description: intl.formatMessage(
        {
          defaultMessage: 'Registration fees payment - {name} (#{id})',
          id: 'label.registration_fees_participant'
        },
        {
          id: get(participant, 'id'),
          name: `${get(participant, 'firstName')} ${get(participant, 'lastName')}`
        }
      ),
      id: get(participant, 'id')
    },
    session: {
      id: get(mpgSession, 'sessionId'),
      version: get(mpgSession, 'version')
    },
    interaction: {
      locale: locale || get(window, 'navigator.language'),
      displayControl: {
        billingAddress: 'HIDE'
      },
      merchant: {
        name: truncate(name, { length: 40 }),
        logo: 'https://www.onlinerecordbook.org/fo/logo.png'
      }
    }
  }
}

export default mpgConfigSchema
